module.exports = __webpack_public_path__ + "img/20200514_154702.4b5363ab.jpg";